module.exports = __webpack_public_path__ + "static/media/Produtos1.7c12c48f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadProdutos/Produtos1.png
// module id = 2000
// module chunks = 0